import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import * as XLSX from "xlsx";

export default function ExcelUpload({ excelFile }) {
  const [uploadedFile, setUploadedFile] = useState("");
  const { t } = useTranslation();

  useEffect(() => {
    if (excelFile) {
      handleFileUpload(excelFile);
    }
  }, [excelFile]);

  const handleFileUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "buffer" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(sheet);
      setUploadedFile(jsonData);
    };
    reader.readAsArrayBuffer(file);
  };
  return (
    <>
      {uploadedFile ? (
        <div
          className="table-responsive"
          style={{ height: "350px", overflow: "auto" }}
        >
          <table className="table">
            <thead>
              <th key={Object.keys(uploadedFile[0])[0]} className="text-center">
                {Object.keys(uploadedFile[0])[0]}
              </th>
            </thead>

            <tbody>
              {uploadedFile.map((individualExcelData, index) => (
                <tr key={index}>
                  {Object.keys(individualExcelData).map((key) => (
                    <td key={key}>{individualExcelData[key]}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p>{t("pages.login.loading", { defaultValue: "Loading" })} ...</p>
      )}
    </>
  );
}
